export default "__VITE_ASSET__C8k52riZ__"